import {put} from 'redux-saga/effects';
import {takeEvery} from 'redux-saga';
import {clearQuestion, getQuestion} from './Question';
import {getContextualLists, clearContextual} from './Contextual';
import {getQuestions} from './Questions';
import {changeKeyword} from './Search';

export const SHOW_HOME = 'app-qa/navigation/SHOW_HOME';
export const showHome = (widget, context, order = 'latest') => ({type: SHOW_HOME, widget, context, order});

export const SHOW_TAG = 'app-qa/navigation/SHOW_TAG';
export const showTag = (widget, tag, context) => ({type: SHOW_TAG, widget, tag, context});

export const SHOW_QUESTION = 'app-qa/navigation/SHOW_QUESTION';
export const showQuestion = (url) => ({type: SHOW_QUESTION, url});

export const SHOW_NEW_QUESTION = 'app-qa/navigation/SHOW_NEW_QUESTION';
export const showNewQuestion = (tag) => ({type: SHOW_NEW_QUESTION, tag, meta: {requireAuthentication: true}});

export const SHOW_EDIT_QUESTION = 'app-qa/navigation/SHOW_EDIT_QUESTION';
export const showEditQuestion = (questionId) => ({
  type: SHOW_EDIT_QUESTION,
  questionId,
  meta: {requireAuthentication: true},
});

export const homeLink = '/';
export const tagLink = (tag) => `/tag/${tag}`;
export const newQuestionLink = (tag) => (tag ? `/create?tag=${tag}` : '/create');
export const questionLink = (url) => `/${url}`;
export const editQuestionLink = (id) => `/edit/${id}`;
export const searchLink = (q) => `/search?q=${q}`;

export function sagas(history) {
  function *navigateToHome({widget, context, order}) {
    yield put(getQuestions(order, undefined, context));
    if (!widget) {
      yield put(getContextualLists([
        {name: 'most-viewed-unanswered', order: 'viewed', showUnanswered: true},
        {name: 'most-popular-tags'},
      ], context));
    }
    yield put(changeKeyword(''));
    history.push(homeLink);
  }

  function *navigateToTag({widget, tag, context}) {
    yield put(getQuestions('latest', tag, context));
    if (!widget) {
      yield put(getContextualLists([
        {name: 'most-viewed-unanswered', order: 'viewed', tag, showUnanswered: true},
        {name: 'most-popular-tags'},
      ], context));
    }
    yield put(changeKeyword(''));
    history.push(tagLink(tag));
  }

  function *navigateToQuestion({url}) {
    yield put(getQuestion(url));
    yield put(changeKeyword(''));
    history.push(questionLink(url));
  }

  function *navigateToNewQuestion({tag}) {
    yield put(clearQuestion());
    yield put(clearContextual());
    yield put(changeKeyword(''));
    history.push(newQuestionLink(tag));
  }

  function *navigateToEditQuestion({questionId}) {
    yield put(getQuestion(questionId));
    yield put(changeKeyword(''));
    history.push(editQuestionLink(questionId));
  }

  return {
    *watchShowHome() { yield* takeEvery(SHOW_HOME, navigateToHome); },
    *watchShowTag() { yield* takeEvery(SHOW_TAG, navigateToTag); },
    *watchShowQuestion() { yield* takeEvery(SHOW_QUESTION, navigateToQuestion); },
    *watchShowNewQuestion() { yield* takeEvery(SHOW_NEW_QUESTION, navigateToNewQuestion); },
    *watchShowEditQuestion() { yield* takeEvery(SHOW_EDIT_QUESTION, navigateToEditQuestion); },
  };
}
